import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { general } from 'src/app/models/general';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-codeudores-externos',
  templateUrl: './codeudores-externos.component.html',
  styleUrls: ['./codeudores-externos.component.css']
})
export class CodeudoresExternosComponent implements OnInit {

  public general
  private pet
  private camposSelect = []
  private select = new Object()
  public autorizaciones = []
  public prod = environment.production
  public exist = true
  constructor(private dialogRef: MatDialogRef<CodeudoresExternosComponent>,
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private messageService: MessageService) {
    this.general = new general()
    this.pet = new general()
  }

  ngOnInit(): void {
  }

  getSelect() {
    this.camposSelect = [
      {
        campo: "TIPONIT",
        tabla: "TIPIDENTIFICACION",
        item1: "CODTIPOIDENTIFICACION",
        item2: "NOMBRETIPOIDEN"
      },
      {
        campo: "CIUDAD_EXP",
        tabla: "CIUDADES_V2",
        item1: "CODCIUDAD",
        item2: "MUNICIPIO"
      },
      {
        campo: "CODCIUDAD_V2",
        tabla: "CIUDADES_V2",
        item1: "CODCIUDAD",
        item2: "MUNICIPIO"
      }
    ]

    for (let i = 0; i < this.camposSelect.length; i++) {
      this.SelectDinamico(this.camposSelect[i].tabla, this.camposSelect[i].item1, this.camposSelect[i].item2, '', this.camposSelect[i].campo)
    }
  }

  SelectDinamico($tabla, $item1, $item2, $item3, $campo) {
    //this._userService.SelectDinamico($tabla, $item1, $item2, $item3).subscribe(
    this.pet['tabla'] = $tabla
    this.pet['item1'] = $item1
    this.pet['item2'] = $item2
    this.pet['item3'] = $item3

    //console.log(this.Actualizacion)
    this._userService.httpPost('selectDinamico', this.pet).subscribe(
      response => {
        this.select[$campo] = response;
      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
        this.messageService.add({ severity: 'error', summary: 'Hubo un error', detail: 'Hubo un problema al cargar el formulario, por favor intentelo de nuevo mas tarde' });
      }
    );
  }

  consultarcod() {
    this.spinner.show();
    if (this.general.cod == '2') {
      this._userService.httpPost('consultarcodext', this.general).subscribe(resp => {
        if (resp.status == 'success') {
          this.dialogRef.close({ nit: this.general.nit });
        } else {
          this.exist = false;
          this.getSelect()
          this.CargarAutorizacion()
        }
        this.spinner.hide();
      },
        error => {
          this.spinner.hide();
          console.log(error)
        })
    } else {
      this._userService.httpGet('validaCodeudor/' + this.general.nit).subscribe(resp => {
        console.log(resp)
        if (resp.estado == 1) {
          this.dialogRef.close({ nit: this.general.nit });
          this.spinner.hide();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'El codeudor no existe como asociado activo' });
          this.spinner.hide();
        }

      })

    }
  }

  guardaCodExt(forma, sig) {
    if (sig) {
      if (this.aceptaAutorizacion()) {
        this.spinner.show()
        this._userService.httpPost('guardarCodExt', this.general).subscribe(resp => {
          if (resp.status == 'success') {
            this.dialogRef.close({ nit: this.general.nit });
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'El codeudor se creo exitosamente' });
          } else {
            Swal.fire({
              icon: 'error',
              text: 'Hubo un problema al crear el codeudor'
            })
          }
          this.spinner.hide()
        },
          error => {
            console.log(error)
            this.spinner.hide()
          })
      } else {
        this.messageService.add({ severity: 'error', summary: 'Autorizaciones', detail: 'Por favor acepte todas las autorizaciones' });
      }
    }
  }

  cerrar() {
    this.dialogRef.close({ data: false });
  }

  CargarAutorizacion() {
    let auth = [
      "WEB_AUTORIZACION_SOLICITUD_1",
      "WEB_AUTORIZACION_SOLICITUD_2",
      "WEB_AUTORIZACION_SOLICITUD_3"
    ]

    for (let i = 0; i < auth.length; i++) {
      let data = {
        autorizacion: auth[i]
      }
      this._userService.httpPost('cargaEntidad', data).subscribe(
        response => {
          if (response['WEBAUTORIZACION'] != '' && response['WEBAUTORIZACION'] != null) {
            this.autorizaciones.push(response['WEBAUTORIZACION'])
          }
        },
        error => {
          console.log(<any>error);
        }
      );
    }
  }

  aceptaAutorizacion() {
    let returnR = false
    for (let i = 0; i < this.autorizaciones.length; i++) {
      if (this.general['auth' + (i + 1)]) {
        returnR = true
      } else {
        returnR = false
      }
    }
    return returnR
  }

}
